import {
  EcommerceSettingsAction,
  LOAD_ECOMMERCE_SETTINGS,
  LOAD_ECOMMERCE_SETTINGS_FAIL,
  LOAD_ECOMMERCE_SETTINGS_SUCCESS,
  LoadEcommerceSettings,
  LoadEcommerceSettingsFail,
  LoadEcommerceSettingsSuccess
} from "../actions";
import {WooCommerceSettings} from "../../websites/website/ecommerce/ecommerce-settings/ecommerce-settings.interface";

export interface IEcommerceSettingsEntityState {
  settings: WooCommerceSettings;
  loading: boolean;
  loaded: boolean;
}

export interface IEcommerceSettingsState {
  entities: { [websiteId: number]: IEcommerceSettingsEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceSettingsState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceSettingsState = initialState, action: EcommerceSettingsAction): IEcommerceSettingsState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_SETTINGS:
      payload = (<LoadEcommerceSettings>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_SETTINGS_SUCCESS:
      payload = (<LoadEcommerceSettingsSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            settings: payload.settings,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_SETTINGS_FAIL:
      payload = (<LoadEcommerceSettingsFail>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };
  }

  return state;
}
